var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"candela-component"},[_c('div',{staticClass:"d-flex flex-wrap flex-grow-1"},_vm._l((_vm.items),function(item,i){return _c('candela-stat-box',_vm._b({key:("stat-box-" + i)},'candela-stat-box',item,false))}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }